module.exports = __webpack_public_path__ + "img/jbtjk.4b1b0842.png";